import { render, staticRenderFns } from "./progress-bar.vue?vue&type=template&id=bb825a56&scoped=true&"
import script from "./progress-bar.vue?vue&type=script&lang=js&"
export * from "./progress-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb825a56",
  null
  
)

export default component.exports